import React, { PropTypes, Component } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as PageActions from "actions/PageActions";

class EscHandler extends Component {
	constructor(props) {
		super(props);
		this.handleEscKeyPress = this.handleEscKeyPress.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

	componentDidMount() {
		window.addEventListener("keyup", this.handleEscKeyPress);
		window.addEventListener("mousedown", this.handleClick);
	}
	componentWillUnmount() {
		window.removeEventListener("keyup", this.handleEscKeyPress);
		window.removeEventListener("mousedown", this.handleClick);
	}
	handleEscKeyPress(e) {
		if (this.props.enabled && event.keyCode === 27) {
			this.props.escape();
			// let { dispatch } = this.props;
			// let actions = bindActionCreators(PageActions, dispatch);
			// actions.escape();
		}
	}
	handleClick(e) {
		let self = this.refs.container;
		let target = e.target;
		if (this.props.enabled && !self.contains(target)) {
			e.preventDefault();
			this.props.escape();
		}
	}
	render() {
		// console.log(this.props);
		return (
			<div ref="container" className="gcrow">{this.props.children}</div>
		);
	}
}

EscHandler.propTypes = {
	enabled: PropTypes.bool.isRequired
};

function mapDispatchToProps(dispatch) {
	return bindActionCreators(PageActions, dispatch);
}

export default connect(null, mapDispatchToProps)(EscHandler);



/** WEBPACK FOOTER **
 ** ./src/scripts/components/misc/EscHandler.jsx
 **/